var $d38897b975d5f445$exports = {};
$d38897b975d5f445$exports = {
    "clear": `\u{900F}\u{660E}`,
    "invalid": `\u{FF08}\u{65E0}\u{6548}\u{FF09}`,
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "noResults": `\u{65E0}\u{7ED3}\u{679C}`
};


export {$d38897b975d5f445$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
